/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Form_ProviderInputs */

const cs_form_provider = /** @type {(inputs: Form_ProviderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poskytovatel`)
};

const en_form_provider = /** @type {(inputs: Form_ProviderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Provider`)
};

/**
* | output |
* | --- |
* | "Provider" |
*
* @param {Form_ProviderInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const form_provider = /** @type {((inputs?: Form_ProviderInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Form_ProviderInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_form_provider(inputs)
	return cs_form_provider(inputs)
});